module.exports = __webpack_public_path__ + "img/damare08.a67ce7cb.jpg";